import { Box, Container, Grid, Typography } from '@mui/material';
import usePageViews from '../../hooks/ga4/usePageViews';
import { useRegisterUser } from '@oai-frontend-monorepo/api';
import { RegistrationType } from '@oai-frontend-monorepo/types';
import RegistrationLogo from '../../components/icons/logo/full-text-logo';
import {
  useErrorStore,
  useUserStore,
} from '@oai-frontend-monorepo/state-management';
import ErrorSnackContainer from '../../components/feedback/errors/error-snack.container';
import logEvent from '../../hooks/ga4/logEvent';
import SignUpPasswords from '../../features/auth/components/sign-up/sign-up-passwords.component';
import { PRIMARY } from '../../libs/mui';
import useSetPassword from '../../features/auth/api/set-password.mutation';
import { useCallback, useEffect, useState } from 'react';
import { useOktaAuth } from '@okta/okta-react';
import cloudApiClient from '../../../../../libs/api/src/lib/clients/cloud-api/cloud-api.client';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import useRenewOktaToken from '../../libs/okta/useRenewOktaToken';
import useSignIn from '../../features/auth/api/sign-in';
import mixpanel from 'mixpanel-browser';
import { parseToken } from '../../../../../libs/utils/src';

const fadeVariants = {
  initial: { opacity: 1 },
  faded: {
    opacity: 0,
    transition: {
      delay: 0,
      duration: 1,
    },
  },
};

const delay = (ms: number) => new Promise((res) => setTimeout(res, ms));

const SignUpPage = () => {
  usePageViews();
  const { oktaAuth } = useOktaAuth();
  const userStore = useUserStore();

  const { mutateAsync: signIn } = useSignIn({
    onSuccess: (d) => {
      console.log('setting token');
      const parsed = parseToken(d);
      mixpanel.identify(parsed?.oai);
      mixpanel.people.set({
        $email: parsed?.sub,
      });

      userStore.setToken(d);

      // onSuccess?.();
    },

    retry: 10,
    ///
    ///
    ///
    ///
  });
  // const nav = useNavigate();

  // password stuff
  // password stuff
  // password stuff
  // password stuff
  // const [searchParams] = useSearchParams();
  // const [token, setToken] = useState<string | undefined>(undefined);

  // const { isLoading, data: passwordResetData } = useSignInWithToken(
  //   token ?? ''
  // );

  const {
    mutateAsync: mutatePassword,
    isPending: passwordPending,
    error: passwordError,
  } = useSetPassword(() => {
    setLoading(false);
  });

  const { renewToken } = useRenewOktaToken();

  useEffect(() => {
    if (!passwordError) return;

    useErrorStore
      .getState()
      .setErrorMessage(passwordError?.message || 'An error occurred');
  }, [passwordError]);

  // const [password, setPassword] = useState<string | undefined>(undefined);

  // useEffect(() => {
  //   if (!passwordResetData || !password) {
  //     return;
  //   }

  //   setTimeout(() => {
  //     handleSetPassword(password);
  //   }, 1);
  // }, [handleSetPassword, password, passwordResetData]);

  // email stuff
  // email stuff
  // email stuff
  // email stuff
  // email stuff
  // email stuff
  const { mutateAsync, isPending } = useRegisterUser({
    onError: (e) => {
      setLoading(false);
      useErrorStore
        .getState()
        .setErrorMessage(e?.message || 'An error occurred');
    },
  });

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (loading) {
      setTimeout(() => {
        window.scrollTo(0, 0);
      }, 100);
    }
  }, [loading]);

  const [checkoutLink, setCheckoutLink] = useState<string | null>(null);

  const handleSubmit = async (
    email: string,
    password: string,
    isAnnual = false,
    firstName?: string,
    lastName?: string
  ) => {
    window.scrollTo(0, 0);
    setLoading(true);

    logEvent({
      action: 'submit-email-button',
      category: 'click',
      label: 'registration',
    });

    console.log('registering user');

    const res = await mutateAsync({
      email,
      registrationType: RegistrationType.SUBSCRIPTION,
      password,
      firstName,
      lastName,
    });

    logEvent({
      action: 'set-password-button',
      category: 'click',
      label: 'registration',
    });

    try {
      console.log('signin in');
      await delay(150);
      await signIn({ email, password });
      await delay(50);

      console.log('loading link');

      const link = await cloudApiClient.getCheckoutLink(isAnnual);

      console.log('Checkout link:', link);
      setCheckoutLink(link);

      window.location.href = link!;
    } catch (err) {
      console.error('Redirect failed:', err);
      // User will see fallback link
    }
  };

  const router = useNavigate();

  return (
    <Container maxWidth={'xl'}>
      <Grid container flex={1} sx={{ minHeight: '100vh' }}>
        <Grid item xs={12} md={6} style={{ minHeight: '100vh' }}>
          <Box maxWidth={600} mx="auto">
            <motion.div
              variants={fadeVariants}
              initial="initial"
              animate={loading ? 'faded' : 'initial'}
            >
              <Box
                onClick={() => {
                  router('/sign-in');
                }}
                py={4}
                display="flex"
              >
                <RegistrationLogo />
              </Box>

              <Typography
                style={{ fontWeight: 700 }}
                my={1}
                color="text.secondary"
                variant="h5"
              >
                Step 1
              </Typography>

              <Typography mb={3} variant="h3">
                Create Your Account
              </Typography>
            </motion.div>

            <SignUpPasswords
              isSubmitting={isPending || loading}
              onSubmit={handleSubmit}
            />

            {checkoutLink && (
              <Box mt={38}>
                <Typography variant="body2">
                  Oops, it looks like your browser prevented the next page from
                  opening automatically.{' '}
                  <a
                    href={checkoutLink}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Click here to continue.
                  </a>
                </Typography>
              </Box>
            )}
          </Box>
        </Grid>

        <Grid
          item
          xs={12}
          md={6}
          display="flex"
          justifyContent={'center'}
          alignItems={'center'}
        >
          <Box
            sx={(theme) => ({
              mx: 4,
              backgroundColor: PRIMARY,
              height: 'calc(100% - 32px)',
              width: '100%',
              borderRadius: 2.25,
              [theme.breakpoints.down('md')]: {
                mx: 0,
              },
            })}
          >
            <Typography
              mb={1}
              pl={6}
              pt={7}
              variant="h3"
              color="white"
              style={{ fontWeight: 500, letterSpacing: 0.4 }}
            >
              See your way to better trades
            </Typography>
            <Typography
              mb={5}
              fontWeight={300}
              maxWidth={450}
              pl={6}
              color="#fff"
              variant="body2"
            >
              Discover lower cost, higher probability trades in seconds with the
              power of visual trading.
            </Typography>

            <Box height={500}>
              <img
                style={{
                  width: '100%',
                  objectFit: 'contain',
                  paddingRight: 12,
                  height: '100%',
                }}
                src="/options-ai-trade.png"
                alt="image"
              />
            </Box>

            <Box
              display={'flex'}
              alignItems="center"
              flexDirection={'row'}
              sx={(theme) => ({
                pt: 1,
                pl: 6,
                [theme.breakpoints.down('md')]: {
                  pl: 2,
                  pt: 0,
                  pb: 8,
                },
              })}
            >
              <Box height={45} width={45}>
                <img
                  style={{
                    width: '100%',
                    objectFit: 'contain',
                    paddingRight: 12,
                    height: '100%',
                  }}
                  src="/image.png"
                  alt="image"
                />
              </Box>

              <Box>
                <Typography ml={0.5} color="white" variant="body2">
                  Connect to Tradier Brokerage for fast, commission-free
                  trading!*
                </Typography>
                <Typography
                  mt={0.25}
                  ml={0.5}
                  color="white"
                  variant="body2"
                  style={{ fontSize: 10, fontWeight: 300 }}
                >
                  *Terms apply
                </Typography>
              </Box>
            </Box>
          </Box>
        </Grid>
      </Grid>

      <ErrorSnackContainer />
    </Container>
  );
};

export default SignUpPage;
